import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import ModalTailwind from '../../components/ModalTailwind';

export default function TablaSolicitudesMedicos() {
  const [solicitudes, setSolicitudes] = useState([]);
  const [filtro, setFiltro] = useState('todos');

  // modal de confirmación
  const [modalShow, setModalShow] = useState(false);
  const [modalData, setModalData] = useState({ id: null, accion: null });

  // modal de resultado
  const [showModal, setShowModal] = useState(false);
  const [modalInfo, setModalInfo] = useState({ status: '', mensaje: '' });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    cargarSolicitudes();
  }, []);

  const cargarSolicitudes = async () => {
    try {
      const res = await axios.get('/api/admin/solicitudes');
      const ordenadas = res.data.slice().sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
      setSolicitudes(ordenadas);
    } catch (err) {
      console.error(err);
    }
  };

  const abrirModalConfirmacion = (id, accion) => {
    setModalData({ id, accion });
    setModalShow(true);
  };

  const confirmarAccion = async () => {
    setLoading(true);
    setModalShow(false);

    try {
      await axios.post(`/api/admin/solicitudes/${modalData.id}/${modalData.accion}`);
      await cargarSolicitudes();

      const mensaje =
        modalData.accion === 'aceptado'
          ? 'Solicitud aceptada con éxito. Información enviada al correo del doctor.'
          : 'Solicitud rechazada con éxito.';

      setModalInfo({ status: modalData.accion, mensaje });
      setShowModal(true);

      setTimeout(() => setShowModal(false), 4000);
    } catch (error) {
      console.error('Error procesando la solicitud', error);
      alert('Ocurrió un error al procesar la solicitud.');
    } finally {
      setLoading(false);
      setModalData({ id: null, accion: null });
    }
  };

  const colorFila = (status) => {
    switch (status) {
      case 'pendiente': return 'bg-yellow-100';
      case 'aceptado': return 'bg-green-100';
      case 'rechazado': return 'bg-red-100';
      default: return '';
    }
  };

  const solicitudesFiltradas = solicitudes.filter(s => filtro === 'todos' ? true : s.status === filtro);

  return (
    <>
      {/* filtros */}
      <div className="mb-4 space-x-2">
        {['todos','pendiente','aceptado','rechazado'].map(f => (
          <button
            key={f}
            onClick={() => setFiltro(f)}
            className="px-3 py-1 border rounded"
          >
            {f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>

      <div className="relative">
        {/* Spinner */}
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-40">
            <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}

        <table className="w-full bg-white shadow-lg rounded">
          <thead className="bg-blue-600 text-white">
            <tr className="text-left">
              <th className="p-3">Nombre</th>
              <th className="p-3">Correo</th>
              <th className="p-3">Especialidad</th>
              <th className="p-3">Currículum</th>
              <th className="p-3">Fecha Solicitud</th>
              <th className="p-3">Estado</th>
              <th className="p-3">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {solicitudesFiltradas.map((solicitud) => (
              <tr key={solicitud.id} className={colorFila(solicitud.status)}>
                <td className="p-3">{solicitud.nombre} {solicitud.apellidos}</td>
                <td className="p-3">{solicitud.correo}</td>
                <td className="p-3">{solicitud.especialidad}</td>
                <td className="p-3">
                  <a
                    href={`/uploads/cvs/${solicitud.cv_url}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline"
                  >
                    Ver CV
                  </a>
                </td>
                <td className="p-3">
                  {new Date(solicitud.fecha).toLocaleString('es-MX', {
                    year: 'numeric', month: '2-digit', day: '2-digit',
                    hour: '2-digit', minute: '2-digit',
                  })}
                </td>
                <td className="p-3 capitalize">
                  {solicitud.status}
                  <br />
                  <span className="text-sm text-gray-500">
                    {solicitud.fecha_actualizacion
                      ? new Date(solicitud.fecha_actualizacion).toLocaleString('es-MX', {
                          year: 'numeric', month: '2-digit', day: '2-digit',
                          hour: '2-digit', minute: '2-digit',
                        })
                      : '-'}
                  </span>
                </td>
                <td className="p-3 space-x-2">
                  {solicitud.status === 'pendiente' && (
                    <>
                      <button
                        onClick={() => abrirModalConfirmacion(solicitud.id, 'aceptado')}
                        className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
                      >
                        Aceptar
                      </button>
                      <button
                        onClick={() => abrirModalConfirmacion(solicitud.id, 'rechazado')}
                        className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                      >
                        Rechazar
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <ModalTailwind
        show={modalShow}
        onClose={() => setModalShow(false)}
        title={`Confirmar ${modalData.accion === 'aceptado' ? 'aceptación' : 'rechazo'}`}
      >
        <p className="text-gray-700 mb-4">
          ¿Estás seguro de que deseas {modalData.accion === 'aceptado' ? 'aceptar' : 'rechazar'} esta solicitud?
        </p>
        <div className="flex justify-end space-x-3">
          <button
            onClick={() => setModalShow(false)}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
          >
            Cancelar
          </button>
          <button
            onClick={confirmarAccion}
            className={`px-4 py-2 text-white rounded ${
              modalData.accion === 'aceptado' ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700'
            }`}
          >
            Confirmar
          </button>
        </div>
      </ModalTailwind>


      {/* Modal de Resultado */}
      <ModalTailwind show={showModal} onClose={() => setShowModal(false)} title="Estado de Solicitud">
        <div className={`flex items-center gap-3 mb-4 ${modalInfo.status === 'aceptado' ? 'text-green-600' : 'text-red-600'}`}>
          <FontAwesomeIcon
            icon={modalInfo.status === 'aceptado' ? faCheckCircle : faTimesCircle}
            className="text-2xl"
          />
          <p className="text-sm sm:text-base">{modalInfo.mensaje}</p>
        </div>
      </ModalTailwind>
    </>
  );
}
